"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessageWrapper = exports.PromptContent = exports.PromptWrapper = void 0;
const styles_1 = require("@mui/material/styles");
const react_animations_1 = require("react-animations");
const slideInAnimation = (0, styles_1.keyframes) `${react_animations_1.slideInUp}`;
const slideOutAnimation = (0, styles_1.keyframes) `${react_animations_1.slideOutDown}`;
exports.PromptWrapper = (0, styles_1.styled)("div", {
    shouldForwardProp: (prop) => prop !== "shouldShowPrompt",
})(({ theme, shouldShowPrompt }) => ({
    position: "fixed",
    zIndex: 300,
    bottom: 0,
    boxShadow: "0px 0px 8px rgba(51, 51, 51, 0.1)",
    width: "100%",
    height: "58px",
    left: 0,
    backgroundColor: theme.palette.grayScale.white,
    animation: !shouldShowPrompt
        ? `0.2s ${slideOutAnimation} forwards`
        : `0.2s ${slideInAnimation} forwards`,
}));
exports.PromptContent = (0, styles_1.styled)("div")(() => ({
    margin: "12px 100px",
    display: "flex",
    justifyContent: "flex-end",
    "button:nth-of-type(2)": {
        marginLeft: "20px",
    },
}));
exports.ErrorMessageWrapper = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(3),
    color: theme.palette.support.error,
}));
